import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Layout, Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { Content } from 'features/content';
import { Remote } from '@okapi/remote';
import { BreadcrumpsSection } from 'features/breadcrumps';
import { AnalyticsPageMeta } from 'features/analytics';
import { SeoDescriptionSection } from 'features/seo-description';
import { getEnv } from 'common/selectors';
import { FooterLayoutContainer, HeaderContainer } from './styles';

export const Brands = memo(() => {
  const { USE_APPSFLYER } = useSelector(getEnv);
  const { t } = useTranslation();

  return (
    <>
      <AnalyticsPageMeta />
      <HeaderContainer>
        <Remote
          widget="header-footer/header"
          id="brandslist-header"
          data={{ pathName: '/brands', disableAppsflyer: !USE_APPSFLYER }}
        />
      </HeaderContainer>
      <Layout>
        <BreadcrumpsSection />
        <Typography variant="h1" as="h1">
          {t('title')}
        </Typography>
        <Content />
        <SeoDescriptionSection />
      </Layout>
      <FooterLayoutContainer>
        <Remote widget="header-footer/footer" id="brandslist-footer" data={{ pathName: '/brands' }} />
      </FooterLayoutContainer>
    </>
  );
});
